import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
@Component({
  selector: 'app-improvement-target-order',
  templateUrl: './improvement-target-order.component.html',
  styleUrl: './improvement-target-order.component.css'
})
export class ImprovementTargetOrderComponent implements ICellRendererAngularComp  {
  refresh(_params: ICellRendererParams): boolean {
    throw new Error('Method not implemented.');
  }
  params;

  agInit(params): void {
    this.params = params;
  }
}
